export const getLocalStorageMetadata = (metaData) => {
    let computedMetaData = metaData;
    if (window.localStorage.getItem('metadata-video-tracking')) {
        const obj = JSON.parse(window.localStorage.getItem('metadata-video-tracking'));
        computedMetaData = {
            ...computedMetaData,
            ...obj,
        };
    }

    // ABTest "homepage-descriptions"
    if (window.localStorage.getItem('abtest_homepage-descriptions')) {
        const hpageDescParams = JSON.parse(
            window.localStorage.getItem('abtest_homepage-descriptions'),
        );
        computedMetaData = {
            ...computedMetaData,
            ...hpageDescParams,
        };
        window.localStorage.removeItem('abtest_homepage-descriptions');
    }
    return computedMetaData;
};
